"use client";

import { PricingInsightFlagsProvider } from "@/contexts/PricingInsightFlagsContext";

/** Shared pricing-insight flags for /sell and /sell/edit (band enforcement + chips). */
export function SellRouteProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return <PricingInsightFlagsProvider>{children}</PricingInsightFlagsProvider>;
}
